import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import type {
  CreateOrderRequest,
  CreateOrderResponse,
  FindOrdersRequestParams,
  FindOrdersResponse,
} from './orders-api';

import type { OrderDetails } from '../model/order';

const BASE_URL = `${config.apiHost}/merchant-portal/api/v1/public/dashboard`;

export async function createOrder(
  order: CreateOrderRequest
): Promise<CreateOrderResponse> {
  const res = await makeRequest<{ payload: CreateOrderResponse }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${config.apiHost}/origination/api/v1/web/pos-online/portal/orders/create`,
    withCredentials: true,
    timeout: 60_000,
    payload: order,
  });
  return res.payload;
}

export async function getOrders(
  params: FindOrdersRequestParams
): Promise<FindOrdersResponse> {
  const res = await makeRequest<{ payload: FindOrdersResponse }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${BASE_URL}/orders`,
    withCredentials: true,
    timeout: 60_000,
    payload: params,
  });
  return res.payload;
}

export async function getOrder(id: string): Promise<OrderDetails> {
  const res = await makeRequest<{ payload: OrderDetails }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${BASE_URL}/orders/get-by-id`,
    withCredentials: true,
    timeout: 60_000,
    payload: { orderId: id },
  });
  return res.payload;
}
